import { EdocAddedBanner } from '../data-models/edoc-added-banner.interface';

export const EdocAddedBannerMockConfig: EdocAddedBanner = {
  companionCertificateLabel: 'Companion Certificate',
  edocBookingMessagesLabel: `You're booking this trip using a Companion Certificate - an exclusive, annual Cardmember benefit of your Delta SkyMiles Credit Card. Remember:<ul><li>If you cancel your itinerary after purchasing, you will not be able to reuse your Companion Certificate</li><li>Your companion passenger is not eligible for mileage accrual</li><li>View Certificateâ€™s Terms & Conditions for complete details</li></ul>`
};
